var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.color,"outlined":""}},[_vm._v(" "+_vm._s(_vm.$t("events.type." + _vm.type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }